
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "NotificationsDate",

  props: {
    date: {
      type: String,
      default: "DD/MM/YYYY",
    },
  },

  setup() {
    function formatDate(isoString: string): string {
      const date = new Date(isoString);

      return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
    }

    return {
      formatDate,
    };
  },
});
